import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';

export const templateTagDetailsForm = document.createElement('template');

templateTagDetailsForm.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='form-wrapper' id='tag-details-form-wrapper'>

    <div id='section-general-details'>
      <gz-title fontSize='18' fontWeight='500' class='form-subtitle' id='general-details-subtitle'></gz-title>

      <div class='form-section'>
        <gz-form-field id='tag-type-form-field' class='label-mw-250' label='' required>
          <gz-radio-group gz-form-input id='tag-type-group' selectedOption="">
            <gz-radio class='pt-1 pb-1' id='tag-type-option-custom'></gz-radio>
            <gz-radio class='pt-1 pb-1' id='tag-type-option-automatic'></gz-radio>
          </gz-radio-group>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='tag-name-form-field' class='label-mw-250' label='' required>
          <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='tag-description-form-field' class='label-mw-250' label=''>
          <gz-textarea gz-form-input hasCounter='true' maxChars='100' placeholder=''></gz-textarea>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field id='tag-company-form-field' class='label-mw-250' label='' required>
          <gz-single-select-complex gz-form-input labelWidth='240'></gz-single-select-complex>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>

    <div id='section-edit-details' class='hidden mb-4'>
        <gz-labeled-content id='tag-type-label' hasFormLabelWidth>
            <gz-title fontSize='12' id='tag-type-info'></gz-title>
        </gz-labeled-content>
        <gz-labeled-content id='tag-created-by-label' hasFormLabelWidth>
            <gz-title fontSize='12' id='tag-created-by-info'></gz-title>
        </gz-labeled-content>
        <gz-labeled-content id='tag-created-on-label' hasFormLabelWidth>
            <gz-title fontSize='12' id='tag-created-on-info'></gz-title>
        </gz-labeled-content>
        <gz-labeled-content id='tag-modified-by-label' hasFormLabelWidth>
            <gz-title fontSize='12' id='tag-modified-by-info'></gz-title>
        </gz-labeled-content>
        <gz-labeled-content id='tag-last-modified-label' hasFormLabelWidth>
            <gz-title fontSize='12' id='tag-last-modified-info'></gz-title>
        </gz-labeled-content>
    </div>

    <div id='section-rule-details' class="section-rule-details">
      <gz-title fontSize='18' fontWeight='500' class='form-subtitle' id='rule-details-subtitle'></gz-title>
      <gz-text fontSize="14" class='mt-2 form-subtitle-info' id='rule-details-subtitle-info'></gz-text>

      <div class='form-section'>

        <gz-form-field id='rules-validation-error-message-form-field' class='hidden'>
          <gz-checkbox gz-form-input label='' class='hidden'></gz-checkbox>
        </gz-form-field>

        <div class='flex-group'>
          <gz-form-field id='endpoint-name-enabled-form-field' class='mt-1'>
            <gz-checkbox gz-form-input label=''></gz-checkbox>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-form-field id='endpoint-name-rule-form-field' class='mb-1' label=''>
            <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <div class='flex-group'>
          <gz-form-field id='ip-enabled-form-field' class='mt-1'>
            <gz-checkbox gz-form-input label=''></gz-checkbox>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-form-field id='ip-rule-form-field' class='mb-1' label=''>
            <gz-input gz-form-input placeholder='' inputWidth='240'></gz-input>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <div class='flex-group'>
          <gz-form-field id='os-enabled-form-field' class='mt-1'>
            <gz-checkbox gz-form-input label=''></gz-checkbox>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-form-field id='os-rule-form-field' class='mb-1' label=''>
            <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <div class='flex-group'>
          <gz-form-field id='endpoint-type-enabled-form-field' class='mt-1'>
            <gz-checkbox gz-form-input label=''></gz-checkbox>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-form-field id='endpoint-type-rule-form-field' class='mb-1' label=''>
            <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

      </div>

    </div>

  </div>
`;
